import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('@/views/Game.vue'),
  },

  {
    path: '/requirementstest',
    name: 'Requirements Test',
    component: () => import('@/views/RequirementsTest.vue'),
  },

  {
    path: '/lockdown',
    name: 'Lockdown Home',
    component: () => import('@/views/CompetitionHome.vue'),
  },
  {
    path: '/lockdown/game',
    name: 'Lockdown Game',
    component: () => import('@/views/CompetitionGame.vue'),
  },

  {
    path: '/forest',
    name: 'Forest Home',
    component: () => import('@/views/ForestHome.vue'),
  },
  {
    path: '/forest/game',
    name: 'Forest Game',
    component: () => import('@/views/ForestGame.vue'),
  },
  {
    path: '/forest/lockdown',
    name: 'Forest Comp Home',
    component: () => import('@/views/CompForestHome.vue'),
  },
  {
    path: '/forest/lockdown/game',
    name: 'Forest Comp Game',
    component: () => import('@/views/CompForestGame.vue'),
  },

  {
    path: '/updown',
    name: 'Up Down Home',
    component: () => import('@/views/UpdownHome.vue'),
  },
  {
    path: '/updown/game',
    name: 'Up Down Game',
    component: () => import('@/views/UpDownGame.vue'),
  },

  {
    path: '/updown/lockdown',
    name: 'Up Down Comp Home',
    component: () => import('@/views/CompUpDownHome.vue'),
  },
  {
    path: '/updown/lockdown2/game',
    name: 'Up Down Comp Game 2',
    component: () => import('@/views/CompUpDownGame2.vue'),
  },
  {
    path: '/updown/lockdown2',
    name: 'Up Down Comp Home 2',
    component: () => import('@/views/CompUpDownHome2.vue'),
  },
  {
    path: '/updown/lockdown/game',
    name: 'Up Down Comp Game',
    component: () => import('@/views/CompUpDownGame.vue'),
  },
  {
    path: '/updown/lockdown/results',
    name: 'Up Down Comp Results',
    component: () => import('@/views/CompUpDownResults.vue'),
  },

  {
    path: '/forest/lockdown/results',
    name: 'Forest Comp Results',
    component: () => import('@/views/CompForestResults.vue'),
  },

  {
    path: '/spot',
    name: 'Spot Home',
    component: () => import('@/views/SpotHome.vue'),
  },
  {
    path: '/spot/game',
    name: 'Spot Game',
    component: () => import('@/views/SpotGame.vue'),
  },

  {
    path: '/spot/lockdown',
    name: 'Spot Lockdown Home',
    component: () => import('@/views/CompSpotHome.vue'),
  },
  {
    path: '/spot/lockdown/game',
    name: 'Spot Lockdown Game',
    component: () => import('@/views/CompSpotGame.vue'),
  },

  {
    path: '/trailo',
    name: 'Trail O Home',
    component: () => import('@/views/TrailOHome.vue'),
  },
  {
    path: '/trailo/game',
    name: 'Trail O Game',
    component: () => import('@/views/TrailOGame.vue'),
  },

  {
    path: '/trailo/lockdown',
    name: 'Lockdown Trail O Home',
    component: () => import('@/views/CompTrailOHome.vue'),
  },
  {
    path: '/trailo/lockdown/game',
    name: 'Lockdown Trail O Game',
    component: () => import('@/views/CompTrailOGame.vue'),
  },

  {
    path: '/memory',
    name: 'Memory O Home',
    component: () => import('@/views/MemoryHome.vue'),
  },
  {
    path: '/memory/game',
    name: 'Memory O Game',
    component: () => import('@/views/MemoryGame.vue'),
  },
  {
    path: '/memory/comp',
    name: 'Comp Memory O Home',
    component: () => import('@/views/CompMemoryHome.vue'),
  },
  {
    path: '/memory/comp/game',
    name: 'Comp Memory O Game',
    component: () => import('@/views/CompMemoryGame.vue'),
  },

  {
    path: '/gaffle',
    name: 'Gaffle Home',
    component: () => import('@/views/CompGaffleHome.vue'),
  },
  {
    path: '/gaffle/game',
    name: 'Gaffle Game',
    component: () => import('@/views/CompGaffleGame.vue'),
  },
  {
    path: '/gaffle/practice',
    name: 'Practice Gaffle Game',
    component: () => import('@/views/GaffleGame.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
